import { createStore, applyMiddleware } from 'redux';
import { logger } from 'redux-logger';
import { RootReducer } from '../reducers/ReducersIndex';

const ApiMiddleware = (store) => (next) => (action) => {
    next(action);
}


export function ConfigureStore(initialState) {
    return createStore(RootReducer, applyMiddleware(logger, ApiMiddleware));
}


// WEBPACK FOOTER //
// ./src/stores/ConfigureStore.tsx